import { useEffect } from 'react'
import ContactComponent from '../components/ui/Contact'

export default function Contact() {
  useEffect(() => {
    document.title = "Contact Us | KES Global Advisors"
  }, [])

  return <ContactComponent />
}
